disableFragmentWarnings